module.exports = __webpack_public_path__ + "media/bootstrap-icons/grid-1x2-82cb8a08.svg";